// extracted by mini-css-extract-plugin
export default {"box":"Chart_box__UA+IA","info":"Chart_info__CWzOs","header":"Chart_header__1lTve"};